export default "__VITE_ASSET__DM5WD2LW__"